module.exports = __webpack_public_path__ + "static/media/stefaanVanDenBogaert.da86d31a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/stefaanVanDenBogaert.jpg
// module id = 1284
// module chunks = 1